import * as React from 'react';
import { useMutation } from '@apollo/client';
import jwtDecode from 'jwt-decode';
import { useTokenContext } from 'src/account/shared/service/token.context';
import { CONFIRM_EMAIL } from 'src/account/create-account/graphql/confirm-email.mutation';
import { useSearchParams } from 'src/shared/hooks/use-search-params';
import { toast } from 'react-toastify';

const getConfirmEmailExpiredError = (expirationHours) => (
  <div className="flex tw-flex-col">
    <p className="tw-font-semibold tw-text-sm">
      Email Confirmation Link Expired
    </p>
    <span className="tw-text-sm">
      Please request a new confirmation email link and use it within{' '}
      {expirationHours} hours.
    </span>
  </div>
);

export const useConfirmEmail = () => {
  const [params] = useSearchParams();
  const [confirmEmail] = useMutation(CONFIRM_EMAIL, {
    onError: () => {
      toast.error(getConfirmEmailExpiredError(4));
    },
  });
  const { saveToken, saveTemporaryToken } = useTokenContext();

  React.useEffect(() => {
    saveToken(null);

    if (params.token) {
      try {
        const decodedToken = jwtDecode(params.token);
        const currentTime = Date.now() / 1000;

        const totalValidHours = Math.ceil(
          (decodedToken.exp - decodedToken.iat) / 3600,
        );

        if (decodedToken.exp && decodedToken.exp < currentTime) {
          toast.error(getConfirmEmailExpiredError(totalValidHours));
          return;
        }

        saveTemporaryToken(params.token);
        confirmEmail();
      } catch (error) {
        toast.error(getConfirmEmailExpiredError(4));
      }
    }
  }, [params.token, confirmEmail, saveToken, saveTemporaryToken]);
};
